// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /squares/presets-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeSquaresPresetsGetBody,
  typeSquaresPresetsGetOutput200,
} from "../../sdk/squares/postSquaresPresetsGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildSquaresPresetsGetQueryKey(
  payload: typeSquaresPresetsGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`leagueKey:${JSON.stringify(payload.leagueKey)}`);
  return [
    "post:squares:squaresPresetsGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeSquaresPresetsGetOutput200,
    unknown,
    typeSquaresPresetsGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useSquaresPresetsGet(
  payload: typeSquaresPresetsGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildSquaresPresetsGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postSquaresPresetsGet(payload),
    ...resolvedOptions,
  });
}
